module.exports = __webpack_public_path__ + "media/images/proof_links/colored/spotify-2235061889bac77495cc5547c6a94dcf.svg";